module.exports = __webpack_public_path__ + "img/2.efbcd23.svg";